export default function setCookieValue(cname: string, pvalue: string) {
  const domainName = document.domain;
  const domain = domainName.indexOf(".") !== -1 ? domainName
    .slice(domainName.indexOf(".")) : domainName;
  document.cookie = cname + "=" + pvalue + ";domain="+ domain + ";path=/";
}
